import PropTypes from "prop-types"
import { Search, Refresh } from "@mui/icons-material"

export default function LegacySearchStatusIcon({ status, className }) {
  switch (status) {
    case "idle":
      return <Search className={className} />
    default:
      return <Refresh className={`spin ${className}`} />
  }
}

LegacySearchStatusIcon.propTypes = {
  status: PropTypes.oneOf(["fetching", "paused", "idle"]),
  className: PropTypes.string,
}
